import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccessLayout } from "../AccessLayout";
import { AccessProps } from "../AccessProps";
import { AccessEntities } from "../AccessEntities";
import { PermissionRow } from "namirasoft-access";
import PermissionPoliciesRolesTables from "../components/PermissionPoliciesRolesTables";

export interface IncomingPermissionListPageProps extends NSARouterMakerResult, AccessProps { }

function IncomingPermissionListPage(props: IncomingPermissionListPageProps)
{
	return (
		<AccessLayout
			{...props}
			action={{
				title: "",
				description: "A list of permissions other users have granted you for their accounts.",
				menus: {}
			}}
			pages={{
				entity: AccessEntities.incomingPermission(props),
				ui: {
					action: {
						menus: {
							view_history: false,
						}
					}
				},
				list: {
					ui: {
						tab_page_view: {
							enabled: true,
							tabs: {
								history: false
							}
						},
						getRowAttributes: (row_value, _, res) =>
						{
							let access_res = res as {
								rows: PermissionRow[];
								count: number;
								session_id: string;
								owner_id: string;
								current_id: string;
							};
							if (access_res.current_id === row_value.id)
								return {
									style: { background: "lightgreen" }
								};
							return {};
						},
						getChildrenAfter: (id) => id
							? <PermissionPoliciesRolesTables
								{...props}
								id={id}
								get={props.servers.access.permission.GetIncoming}
							/>
							: <></>
					}
				}
			}}
		>
			<></>
		</AccessLayout>
	);
}

export default IncomingPermissionListPage;